import { createColumnHelper } from '@tanstack/react-table';

import type { DockerRegistryFormData } from '../../types';

export type AccessRow = DockerRegistryFormData['accessRows'][0] & {
  registryName?: string;
};

export const columnHelper = createColumnHelper<AccessRow>();
